export const GIGITAL_VERSION = `gigital@1.1.0`;

export const COMPANY_REPLACE_STRING = '$$COMPANYNAME$$';
